import React from 'react';
import moment from 'moment';

import {
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineContent,
} from '@material-ui/lab';
import { makeStyles, Paper, Theme, Typography } from '@material-ui/core';

import { HourglassEmpty } from '@material-ui/icons';

const useStyles = makeStyles((theme: Theme) => ({
  paper: {
    padding: '6px 16px',
  },
  content: {
    padding: theme.spacing(2, 1),
  },
  opposite: {
    maxWidth: '30%',
  },
  secondaryTail: {
    backgroundColor: theme.palette.primary.main,
  },
}));

const EmptyProgress: React.FC = () => {
  const classes = useStyles();

  return (
    <TimelineItem key="empty">
      <TimelineOppositeContent className={classes.opposite}>
        <Typography variant="body1" color="textSecondary">
          {moment().format('DD/MM/YYYY HH:mm')}
        </Typography>
      </TimelineOppositeContent>
      <TimelineSeparator>
        <TimelineDot color="inherit">
          <HourglassEmpty />
        </TimelineDot>
      </TimelineSeparator>
      <TimelineContent className={classes.content}>
        <Paper elevation={4} className={classes.paper}>
          <Typography variant="h6" component="h1">
            Sem evoluções
          </Typography>
          <Typography>Nenhuma evolução registrada no prontuário.</Typography>
        </Paper>
      </TimelineContent>
    </TimelineItem>
  );
};

export default EmptyProgress;
